import { Link } from "react-router-dom";
import { usePageMeta } from "@/lib/usePageMeta";

export default function NotFoundPage() {
  usePageMeta("Page Not Found", "The page you requested could not be found.");
  return (
    <section data-testid="not-found-page" className="min-h-[80svh] flex items-end bg-[var(--bg-deepest)] grain pt-40 pb-24">
      <div className="container-x">
        <p className="eyebrow mb-4">404</p>
        <h1 className="font-display font-black uppercase leading-[0.9] tracking-tight text-white text-5xl md:text-7xl lg:text-8xl">
          This Page <br /> Got <span className="brand-red">RE//FORMED</span>
        </h1>
        <p className="mt-6 text-white/60 max-w-md">The page you're looking for has moved or no longer exists.</p>
        <div className="mt-10 flex flex-wrap gap-3">
          <Link to="/" className="btn-primary-sharp" data-testid="not-found-home">Back Home</Link>
          <Link to="/contact" className="btn-outline-sharp" data-testid="not-found-contact">Contact Us</Link>
        </div>
      </div>
    </section>
  );
}
